import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ProjectsFacade,
  getRolesAndPermission,
  getRolesAndPermissionForProject,
} from '@piqet-angular/data';
import { mainModuleName, rolesModuleName } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'piqet-angular-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.css'],
})
export class ProjectDetailsComponent implements OnInit {
  activatedRoute: any;
  projectName: any;
  flagName: any;
  sidebarTour = false;
  isViewOnly = false;
  isEdit = true;
  scrollTrigger!: Subscription;

  constructor(
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public projectFacade: ProjectsFacade,
    public router: Router,
    private viewportScroller: ViewportScroller
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    this.route.queryParams.subscribe((data: any) => {
      this.flagName = Boolean(data['flagName']);
    });
    this.isViewOnly = this.isProjectAccess(this.activatedRoute)
      ? this.isProjectAccess(this.activatedRoute).isView
      : false;
    this.isEdit = this.isProjectAccess(this.activatedRoute)
      ? this.isProjectAccess(this.activatedRoute).isOverview
      : true;
  }

  isProjectAccess = (pathName: any) => {
    return pathName == 'admin-projects'
      ? getRolesAndPermission(
          rolesModuleName.AdministratorProjects,
          mainModuleName.projectManagementModule
        )
      : getRolesAndPermissionForProject(
          rolesModuleName.packageScenario,
          mainModuleName.projectsModule
        );
  };

  ngOnInit(): void {
    this.scrollTrigger = this.sharedService.scrollTriggered$.subscribe(() => {
      this.scrollToTop();
    });
    this.sharedService.scrollToBottom$.subscribe(() => {
      this.scrollToBottom();
    });
  }

  handleData(event: any) {
    this.projectName = event;
  }

  scrollToTop(): void {
    const parentElement = document.querySelector('.contentDiv');
    if (parentElement) {
      parentElement.scrollTop = 0;
      this.viewportScroller.scrollToPosition([0, 0]);
    }
  }
  scrollToBottom(): void {
    const parentElement = document.querySelector('.contentDiv');
    if (parentElement) {
      parentElement.scrollTop = parentElement.scrollHeight;
    }
  }

  startTour() {}

  ngOnDestroy() {
    this.scrollTrigger.unsubscribe();
  }
}
